{
  "Poll_Viewer_VoteCount_Modal_Voters_Private_Voter": "Private User",
  "Poll_Viewer_ShowAllOptions_CTA": "See All Options",
  "Spoiler_Reveal_Tooltip": "Click to reveal",
  "VerticalEmbed_Event_Error_Subtitle": "This event has been deleted, replace it with another event.",
  "Viewer_Toolbar_Twitter_Tooltip": "Tweet this",
  "CollapsibleListPlugin_CollapseButton_AriaLabel": "Item is collapsed",
  "Spoiler_Reveal_Video_CTA": "Reveal Video",
  "VerticalEmbed_Pricing_Plan": "Plan only",
  "Image_Expand_Button_AriaLabel": "Expand image",
  "VerticalEmbed_From_Price": "From",
  "Poll_Viewer_ShowAllResults_CTA": "See All Results",
  "Spoiler_Reveal_Image_Placeholder": "This image contains a spoiler",
  "VerticalEmbed_Ribbon": "Sale",
  "Audio_Plugin_Elapsed_Time_Slider_AriaLabel": "Seek slider",
  "VerticalEmbed_Error_Subtitle": "This item has been deleted, replace it with another item.",
  "Poll_Viewer_Multiselect_Footer": "You can vote for more than one answer.",
  "Audio_Plugin_More_Actions_Button_AriaLabel": "Show more audio controls",
  "VerticalEmbed_Booking_Fetch_Error_Title": "Service couldn’t be loaded",
  "Fullscreen_Close_Button_AriaLabel": "Close",
  "VerticalEmbed_Event_Fetch_Error_Title": "Event couldn't be loaded",
  "UploadFile_Viewer_Loader": "Loading {{fileType}}",
  "Polls_Plugin_User_Avatar_Alt": "User avatar",
  "Preview_ReadMore_Label": "Read more",
  "Spoiler_Insert_Tooltip": "Spoiler",
  "VerticalEmbed_Product_Fetch_Error_Title": "Product couldn’t be loaded",
  "Fullscreen_Shrink_Button_AriaLabel": "Shrink",
  "Audio_Plugin_Volume_Control_Slider_AriaLabel": "Volume",
  "Spoiler_Reveal_Gallery_Placeholder": "This gallery contains a spoiler",
  "Fullscreen_Expand_Button_AriaLabel": "Expand",
  "VerticalEmbed_Bookings_Button": "Book Now",
  "Audio_Plugin_Volume_Control_Unmute_AriaLabel": "Unmute",
  "Spoiler_Reveal_Gallery_CTA": "Reveal Gallery",
  "Poll_Viewer_ShowLess_CTA": "Show Less",
  "VerticalEmbed_Disabled_Button_Tooltip": "Product page will be available once you publish your site.",
  "Audio_Plugin_Volume_Control_Mute_AriaLabel": "Mute",
  "Poll_Viewer_VoteCount_Modal_Voters_Anonymous": "+{{anonNumber}} anonymous",
  "Poll_Viewer_VoteCount_Modal_Voters_CTA_Follow": "Follow",
  "VerticalEmbed_Products_Button": "Buy Now",
  "Poll_Viewer_Toast_Error_ServerDown": "Couldn't connect to server. Try again later.",
  "Poll_Viewer_VoteCount_Modal_Voters_Header": "{{count}} person voted for this answer",
  "Poll_Viewer_VoteCount": "{{number}} votes",
  "VerticalEmbed_Events_Button": "Register Now",
  "Spoiler_Reveal_Image_CTA": "Reveal Image",
  "Poll_Viewer_Toast_Error_Connection": "No internet. Check your connection.",
  "Poll_Viewer_Visibility_Owner_Footer": "Only you can see the results.",
  "VerticalEmbed_Booking_Error_Title": "Service deleted",
  "VerticalEmbed_Product_Error_Title": "Product deleted",
  "VerticalEmbed_Fetch_Error_Subtitle": "Unable to load item information.",
  "Poll_Viewer_VoteCount_Modal_Voters_Header_plural": "{{count}} people voted for this answer",
  "VerticalEmbed_Event_Error_Title": "Event deleted",
  "CollapsibleListPlugin_ExpandButton_AriaLabel": "Item is expanded",
  "Audio_Plugin_Cover_Alt": "Audio cover",
  "Spoiler_Reveal_Video_Placeholder": "This video contains a spoiler",
  "VerticalEmbed_Product_Fetch_Error_Subtitle": "There was a technical issue. Check your connection or try again.",
  "VerticalEmbed_Fetch_Error_Title": "Failed to load item",
  "Poll_Viewer_Option_AriaLabel_Unchecked": "unchecked",
  "VerticalEmbed_Product_Error_Subtitle": "This product has been deleted, replace it with another product.",
  "VerticalEmbed_Booking_Error_Subtitle": "This service has been deleted, replace it with another service.",
  "Preview_SeeFullPost_Label": "See Full Post",
  "UploadFile_Viewer_Download": "Download {{fileType}}",
  "VerticalEmbed_Units_Hour": "{{hours}}h",
  "VerticalEmbed_Units_Minute": "{{minutes}}min",
  "VerticalEmbed_Event_Fetch_Error_Subtitle": "There was a technical issue. Check your connection or try again.",
  "VerticalEmbed_Error_Button": "Replace",
  "VerticalEmbed_Error_Title": "Item deleted",
  "VerticalEmbed_Booking_Fetch_Error_Subtitle": "There was a technical issue. Check your connection or try again.",
  "Poll_Viewer_Option_AriaLabel_Checked": "checked"
}
